/**
 * MFA step types from MFA API Contracts (Login).
 * Used with POST /v1/mfa/session/step and step/action.
 */
export default {
  OTP: 'OTP',
  IVR: 'IVR',
  PASSCODE: 'PASSCODE',
  FACE_SCAN: 'FACE_SCAN',
  IN_APP_APPROVAL: 'IN_APP_APPROVAL',
}

/**
 * Verification providers returned by mfaStepTransition in stepTypeData.provider.
 * NAFATH: Saudi Nafath – providerData has status, transId, random, expireTime.
 * UAEKYC: UAE KYC – providerData has journeyToken.
 */
export const MFA_VERIFICATION_PROVIDERS = {
  NAFATH: 'NAFATH',
  UAEKYC: 'UAEKYC',
}

/** POST …/step/action `stepTypeData.action` values that resend OTP (init-like SUCCESS body). */
export const MFA_STEP_ACTIONS = {
  RESEND_OTP: 'RESEND_OTP',
  SEND_OTP: 'SEND_OTP',
}
